export const fmtDate = (iso, opts) => {
  if (!iso) return "—";
  const d = new Date(iso.length === 10 ? `${iso}T00:00:00` : iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("en-GB", opts || { day: "numeric", month: "short", year: "numeric" });
};

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString("en-GB", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
};

export const fmtMoney = (n) => `£${Number(n || 0).toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const REQUEST_STATUS = {
  draft: { label: "Under Review", cls: "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300" },
  pending_review: { label: "Under Review", cls: "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300" },
  awaiting_quotes: { label: "Gathering Quotes", cls: "bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-400" },
  quotes_received: { label: "Quotes Received", cls: "bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-400" },
  submitted_to_client: { label: "Awaiting Your Approval", cls: "bg-purple-100 text-purple-700 dark:bg-purple-900/40 dark:text-purple-400" },
  client_approved: { label: "Approved — Scheduling", cls: "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-400" },
  converting: { label: "Scheduling", cls: "bg-cyan-100 text-cyan-700 dark:bg-cyan-900/40 dark:text-cyan-400" },
  converted: { label: "Job Created", cls: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300" },
  declined: { label: "Declined", cls: "bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-400" },
  on_hold: { label: "On Hold", cls: "bg-orange-100 text-orange-700 dark:bg-orange-900/40 dark:text-orange-400" },
};

export const requestStatusMap = (r) => (r?.request_type === "project" && r?.status === "converted") ? { ...REQUEST_STATUS, converted: { ...REQUEST_STATUS.converted, label: "Project Live" } } : REQUEST_STATUS;

export const JOB_STATUS = {
  scheduled: { label: "Scheduled", cls: "bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-400" },
  in_progress: { label: "In Progress", cls: "bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-400" },
  completed: { label: "Completed", cls: "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-400" },
  cancelled: { label: "Cancelled", cls: "bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400" },
};

export const EMERGENCY_STATUS = {
  open: { label: "Reported", cls: "bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-400" },
  acknowledged: { label: "Acknowledged", cls: "bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-400" },
  assigned: { label: "Contractor Assigned", cls: "bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-400" },
  in_progress: { label: "Contractor On Site", cls: "bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-400" },
  completed: { label: "Resolved", cls: "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-400" },
  cancelled: { label: "Cancelled", cls: "bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400" },
};

export const INVOICE_STATUS = {
  draft: { label: "Draft", cls: "bg-slate-100 text-slate-700" },
  sent: { label: "Awaiting Payment", cls: "bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-400" },
  issued: { label: "Awaiting Payment", cls: "bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-400" },
  overdue: { label: "Overdue", cls: "bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-400" },
  paid: { label: "Paid", cls: "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-400" },
  cancelled: { label: "Cancelled", cls: "bg-slate-100 text-slate-600" },
};

export const PROJECT_STATUS = {
  draft: { label: "Being Planned", cls: "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300" },
  planning: { label: "Being Planned", cls: "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300" },
  planned: { label: "Planned", cls: "bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-400" },
  active: { label: "In Progress", cls: "bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-400" },
  in_progress: { label: "In Progress", cls: "bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-400" },
  awaiting_vendor: { label: "Awaiting Contractor", cls: "bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-400" },
  awaiting_approval: { label: "Awaiting Sign-off", cls: "bg-purple-100 text-purple-700 dark:bg-purple-900/40 dark:text-purple-400" },
  on_hold: { label: "On Hold", cls: "bg-orange-100 text-orange-700 dark:bg-orange-900/40 dark:text-orange-400" },
  completed: { label: "Completed", cls: "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-400" },
  closed: { label: "Closed", cls: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300" },
  cancelled: { label: "Cancelled", cls: "bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400" },
};

export const TASK_STATUS = {
  not_started: { label: "Not Started", cls: "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300" },
  assigned: { label: "Scheduled", cls: "bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-400" },
  in_progress: { label: "In Progress", cls: "bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-400" },
  completed_by_vendor: { label: "Awaiting Sign-off", cls: "bg-purple-100 text-purple-700 dark:bg-purple-900/40 dark:text-purple-400" },
  approved: { label: "Completed", cls: "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-400" },
  rejected: { label: "Rework Required", cls: "bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-400" },
  on_hold: { label: "On Hold", cls: "bg-orange-100 text-orange-700 dark:bg-orange-900/40 dark:text-orange-400" },
  cancelled: { label: "Cancelled", cls: "bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400" },
};

export const QUOTE_STATUS = {
  sent: { label: "Awaiting Your Decision", cls: "bg-purple-100 text-purple-700 dark:bg-purple-900/40 dark:text-purple-400" },
  approved: { label: "Approved", cls: "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-400" },
  declined: { label: "Declined", cls: "bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-400" },
  converted: { label: "Approved — Job Created", cls: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300" },
};

export const URGENCY = {
  critical: { label: "Critical", hours: 4, cls: "bg-red-600 text-white" },
  urgent: { label: "Urgent", hours: 8, cls: "bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-400" },
  moderate: { label: "Moderate", hours: 12, cls: "bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-400" },
  minor: { label: "Minor", hours: 24, cls: "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300" },
};

export const CATEGORIES = ["general", "maintenance", "reactive_repair", "planned_works", "inspection", "electrical", "plumbing", "heating", "roofing", "structural", "refurbishment", "fit_out", "renovation", "mould_eradication", "cleaning", "landscaping", "other"];

export const TIER_LABEL = { client_admin: "Administrator", client_user: "User", client_viewer: "Viewer" };
export const TIER_DESC = {
  client_admin: "Invite & manage team, approve quotes, confirm payments, everything below",
  client_user: "Raise requests & emergencies, upload photos, comment, manage properties",
  client_viewer: "Read-only access to jobs, requests, calendar, invoices and files",
};

export const titleCase = (s) => (s || "").replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
